import React, { useState } from "react";
import { Box, Dialog } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";

export default function ImageThumb({ src, alt, size = 48, zoomable = false }) {
  const [open, setOpen] = useState(false);
  const clickable = zoomable && !!src;

  return (
    <>
      <Box
        onClick={clickable ? () => setOpen(true) : undefined}
        sx={{
          width: size,
          height: size,
          borderRadius: 1,
          bgcolor: "rgba(0,0,0,0.04)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          flexShrink: 0,
          cursor: clickable ? "zoom-in" : "default",
        }}
      >
        {src ? (
          <Box
            component="img"
            src={src}
            alt={alt || ""}
            sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
          />
        ) : (
          <ImageIcon sx={{ color: "rgba(0,0,0,0.25)", fontSize: size * 0.55 }} />
        )}
      </Box>

      {clickable && (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
          <Box
            component="img"
            src={src}
            alt={alt || ""}
            onClick={() => setOpen(false)}
            sx={{
              display: "block",
              maxWidth: "90vw",
              maxHeight: "85vh",
              objectFit: "contain",
              cursor: "zoom-out",
            }}
          />
        </Dialog>
      )}
    </>
  );
}
